import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { useTranslation } from 'next-i18next';

const HeaderHeadline = styled.h2`
	background-color: var(--transparentWhite50);

	${media.xl`
		background-color: transparent;
	`}
`;

const HeaderImage = () => {
	const [t] = useTranslation(['translation']);
	return (
		<div className='position-relative mx-n4 mt-n4 mb-4'>
			<img
				src='/img/banner/20250417_Vetopedia_Banner_Impfschaden_v01.png'
				className='w-100 rounded-4'
			/>
			<HeaderHeadline
				className='p-4 position-absolute top-0 text-white
				display-3 text-center'
			>
				{t('common.impfschaeden')}
			</HeaderHeadline>
		</div>
	);
};

export default HeaderImage;
